/** @format */

import Header from "./Components/Header";
import Solidarios from "./Pages/Solidarios";
import Contenidos from "./Components/Contenidos";
import Foro from "./Pages/Foro";
import Cursos from "./Pages/Cursos";
import Tickets from "./Pages/Tickets";
import RutaProtegida from "./Pages/RutaProtegida";
import Login from "./Components/Login";
import { useSelector } from "react-redux";
import "bootstrap-icons/font/bootstrap-icons.css";
import {
  HashRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import Footer from "./Components/Footer";
import Datos from "./Pages/Datos";

function App() {
  var mobileNavActive = useSelector((state) => state.isMobileNavActive);
  const isLoggedIn = useSelector((state) => state.isLoggedIn);

  return (
    <HashRouter>
      <div className={` ${mobileNavActive ? "mobile-nav-active" : ""}`}>
        <Header loggedin={isLoggedIn} />
        <Routes>
          {/* Rutas específicas */}
          <Route
            path='/'
            element={
              <RutaProtegida>
                <Solidarios />
              </RutaProtegida>
            }
          />

          {/* Rutas dinámicas */}
          <Route
            path='/signin'
            element={!isLoggedIn ? <Login /> : <Navigate to='/' />}
          />
          <Route
            path='/solidarios'
            element={
              <RutaProtegida>
                <Solidarios />
              </RutaProtegida>
            }
          />
          <Route
            path='/contenidos'
            element={isLoggedIn ? <Contenidos /> : <Navigate to='/' />}
          />
          <Route
            path='/datos'
            element={isLoggedIn ? <Datos /> : <Navigate to='/' />}
          />
          <Route
            path='/tickets'
            element={isLoggedIn ? <Tickets /> : <Navigate to='/' />}
          />
          <Route
            path='/foro'
            element={isLoggedIn ? <Foro /> : <Navigate to='/' />}
          />
          <Route
            path='/cursos'
            element={isLoggedIn ? <Cursos /> : <Navigate to='/' />}
          />
        </Routes>
      </div>
      <Footer loggedin={isLoggedIn} />
    </HashRouter>
  );
}

export default App;
